import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=60f6e63a"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f6e63a')) {
      api.createRecord('60f6e63a', component.options)
    } else {
      api.reload('60f6e63a', component.options)
    }
    module.hot.accept("./DeliveryAddress.vue?vue&type=template&id=60f6e63a", function () {
      api.rerender('60f6e63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/DeliveryAddress.vue"
export default component.exports